import React, { useContext, useEffect, useState, Suspense, lazy } from "react"
import { BrowserRouter, Switch } from "react-router-dom"
import { ToastContainer } from "react-toastify"
import { AuthProvider } from "../context/Auth/AuthContext"
import { TicketsContextProvider } from "../context/Tickets/TicketsContext"
import { WhatsAppsProvider } from "../context/WhatsApp/WhatsAppsContext"
import Route from "./Route"
import { defaultTheme, Provider } from "@adobe/react-spectrum"
import { ColorModeContext } from "../layout/themeContext"
import LoggedInLayout from "../layout"

// 🔹 Importações lazy (carregam sob demanda)
const TicketResponsiveContainer = lazy(() => import(/* webpackPrefetch: true */ "../pages/TicketResponsiveContainer"))
const Login = lazy(() => import("../pages/Login/"))
const Connections = lazy(() => import("../pages/Connections/"))
const SettingsCustom = lazy(() => import("../pages/SettingsCustom/"))
const Users = lazy(() => import(/* webpackChunkName: "admin-users" */ "../pages/Users"))
const Contacts = lazy(() => import("../pages/Contacts/"))
const Queues = lazy(() => import(/* webpackChunkName: "admin-queues" */ "../pages/Queues/"))
const Situacoes = lazy(() => import("../pages/Situacoes/"))
const Campaigns = lazy(() => import(/* webpackChunkName: "admin-campaigns" */ "../pages/Campaigns/"))
const CampaignsConfig = lazy(() => import(/* webpackChunkName: "admin-campaigns-config" */ "../pages/CampaignsConfig/"))
const CampaignReport = lazy(() => import("../pages/CampaignReport/"))
const ContactLists = lazy(() => import("../pages/ContactLists/"))
const ContactListItems = lazy(() => import("../pages/ContactListItems/"))
const QuickMessages = lazy(() => import("../pages/QuickMessages/"))
const Kanban = lazy(() => import("../pages/Kanban"))
const Schedules = lazy(() => import("../pages/Schedules"))
const Annoucements = lazy(() => import("../pages/Annoucements"))
const Dashboard = lazy(() => import(/* webpackPrefetch: true */ "../pages/Dashboard"))
const PortalClienteGuard = lazy(() => import(/* webpackChunkName: "admin-portal-cliente" */ "../pages/PortalCliente/PortalClienteGuard"))

const Routes = () => {
  const [showCampaigns, setShowCampaigns] = useState(false)
  const { currentMode } = useContext(ColorModeContext)

  useEffect(() => {
    const cshow = localStorage.getItem("cshow")
    if (cshow !== undefined) {
      setShowCampaigns(true)
    }
  }, [])

  return (
    <BrowserRouter>
      <AuthProvider>
        <TicketsContextProvider>
          <Suspense fallback={null}>
            <Switch>
              <Route exact path="/login" component={Login} />
              <WhatsAppsProvider>
                <LoggedInLayout>
                  <Route exact path="/conversas/:ticketId?" component={TicketResponsiveContainer} isPrivate />
                  <Route exact path="/connections" component={Connections} isPrivate />
                  <Route exact path="/quick-messages" component={QuickMessages} isPrivate />
                  <Route exact path="/schedules" component={Schedules} isPrivate />
                  <Route exact path="/situacoes" component={Situacoes} isPrivate />
                  <Route exact path="/contacts" component={Contacts} isPrivate />
                  <Route exact path="/users" component={Users} isPrivate />
                  <Route exact path="/portal-cliente" component={PortalClienteGuard} isPrivate />
                  <Provider theme={defaultTheme} colorScheme={currentMode}>
                    <Route exact path="/dashboard" component={Dashboard} isPrivate />
                  </Provider>
                  {/* Fluxo de conversas desabilitado
                  <Route exact path="/fluxo" component={FluxoDeConversas} isPrivate />
                  */}
                  <Route exact path="/settings" component={SettingsCustom} isPrivate />
                  <Route exact path="/kanban" component={Kanban} isPrivate />
                  <Route exact path="/queues" component={Queues} isPrivate />
                  <Route exact path="/announcements" component={Annoucements} isPrivate />
                  {showCampaigns && (
                    <>
                      <Route exact path="/contact-lists" component={ContactLists} isPrivate />
                      <Route
                        exact
                        path="/contact-lists/:contactListId/contacts"
                        component={ContactListItems}
                        isPrivate
                      />
                      <Route exact path="/campaigns" component={Campaigns} isPrivate />
                      <Route exact path="/campaign/:campaignId/report" component={CampaignReport} isPrivate />
                      <Route exact path="/campaigns-config" component={CampaignsConfig} isPrivate />
                    </>
                  )}
                </LoggedInLayout>
              </WhatsAppsProvider>
            </Switch>
          </Suspense>
          <ToastContainer autoClose={3000} />
        </TicketsContextProvider>
      </AuthProvider>
    </BrowserRouter>
  )
}

export default Routes
